<div class="d-flex justify-content-between align-items-center pb-3">
  <div class="rental-title">
    <ng-container *ngIf="rental">
      <app-rental-image [rental]="rental" [size]="40"></app-rental-image>
      {{ rental.name }}
    </ng-container>
    <app-page-help videoId="wECpT72w4h8" class="ml-2"></app-page-help>
  </div>

  <div class="text-black-50">
    <div *ngIf="isAnySelected()">{{ getSelected().length }} items are selected.</div>
  </div>

  <div class="buttons-container">
    <button
      type="button"
      class="btn btn-danger text-uppercase"
      [disabled]="!isAnySelected() || isDeleting || !groupRatesLoaded || (1 | isReadonlyRole)"
      (click)="onDelete()"
    >
      <i class="fal {{ isDeleting ? 'fa-spinner fa-spin' : 'fa-trash-alt' }}"></i>
      <ng-container *ngIf="isAllSelected(false)"> Delete All Rates </ng-container>
      <ng-container *ngIf="!isAllSelected(false)">Delete</ng-container>
    </button>

    <div class="btn-group" dropdown [isDisabled]="1 | isReadonlyRole">
      <button type="button" class="btn btn-success text-uppercase dropdown-toggle" dropdownToggle>
        <span class="{{ rateIcon }}"></span> Add {{ rateLabel }}s <span class="caret"></span>
      </button>
      <ul class="dropdown-menu dropdown-menu-right" *dropdownMenu>
        <li>
          <button
            type="button"
            (click)="onAddStandardRate()"
            matTooltip="Standard rates are flat, constant rates which do not change over time."
            matTooltipPosition="left"
          >
            <i class="{{ rateIcon }}"></i> Add Standard {{ rateLabel }}
          </button>
        </li>
        <li>
          <button
            type="button"
            (click)="onAddDynamicRate()"
            matTooltip="Dynamic rates will gradually and automatically adjust from a low rate to a high rate as your overall rental occupancy level changes. They can also instantly update your channels as the rate changes."
            matTooltipPosition="left"
          >
            <i class="{{ rateIcon }}"></i> Add Dynamic {{ rateLabel }}
          </button>
        </li>
      </ul>
    </div>
  </div>
</div>

<div class="filters-container" [ngClass]="{ 'group-rates': isGroupRates, 'rental-rates': !isGroupRates }">
  <mat-form-field
    class="field-categories"
    floatLabel="never"
    matTooltip="Filter the below rates by category."
    matTooltipPosition="below"
    matTooltipClass="text-center"
  >
    <mat-select [formControl]="categoryControl" placeholder="Category">
      <mat-option value="*">All categories</mat-option>
      <mat-option *ngFor="let category of categories$ | async" [value]="category">{{ category }}</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field
    class="field-period"
    floatLabel="never"
    matTooltip="Filter the below rates by period."
    matTooltipPosition="below"
    matTooltipClass="text-center"
  >
    <app-date-range-form-control placeholder="Rate Period" [formControl]="periodControl"></app-date-range-form-control>
  </mat-form-field>

  <app-select-search
    *ngIf="isGroupRates"
    floatLabel="never"
    bindValue="id"
    bindLabel="name"
    [items]="filteredRentals$ | async"
    [ctrl]="rentalsControl"
    placeholder="Rentals"
  >
  </app-select-search>

  <div class="spacer"></div>

  <mat-form-field class="mat-block" floatLabel="never">
    <input type="text" matInput placeholder="Search rates" [formControl]="searchControl" />
    <i
      *ngIf="searchControl.value?.length > 0"
      (click)="$event.stopPropagation(); searchControl.patchValue('')"
      class="far fa-times cancel-search"
    ></i>
  </mat-form-field>

  <div class="btn-clear-filters" matTooltip="Clear all filters" (click)="clearFilters()">
    <i class="fal fa-minus-circle"></i>
  </div>
</div>

<div class="table-holder table-responsive">
  <table class="table table-default table-striped">
    <mat-table #table matSort matSortActive="period" matSortDirection="asc" [dataSource]="dataSource">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef>
          <mat-checkbox
            [checked]="selection.hasValue() && isAllSelected(isSelectAllRenderedItems)"
            [indeterminate]="selection.hasValue() && !isAllSelected(isSelectAllRenderedItems)"
            [disabled]="!isGroupRates && !(hasRentalRates | call : dataSource.data)"
            (change)="onMasterToggle($event?.checked)"
            class="master-toggle"
          >
          </mat-checkbox>
          <div class="btn-group master-toggle-group" dropdown container="body" [isDisabled]="!dataSource.data?.length">
            <div dropdownToggle>
              <i class="fa fa-caret-down ml-2"></i>
            </div>
            <ul class="dropdown-menu" *dropdownMenu>
              <li>
                <button type="button" (click)="onSelectAll(true)">All</button>
              </li>
              <li>
                <button type="button" (click)="onSelectAll(false)">All Visible</button>
              </li>
              <li>
                <button type="button" (click)="onMasterToggle(false)">None</button>
              </li>
            </ul>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let row">
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)"
            [disabled]="!isGroupRates && (isGroupRate | call : row)"
          >
          </mat-checkbox>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header>
          <span
            matTooltip="Rate categories are used to group multiple rates together. Rates in a Rate Category cannot overlap. When updating a channel you push a single rate category. All rates in that category will be pushed to the channel."
            matTooltipClass="text-center"
            matTooltipPosition="above"
          >
            Category <i class="fas fa-info-circle"></i>
          </span>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ getRateCategory | call : element }}
          <b *ngIf="element.type === 'dynamic'" matTooltip="Dynamic Rate" matTooltipPosition="right">(D)</b>
          <b *ngIf="element.type === 'promotion'" matTooltip="Promotional Rate" matTooltipPosition="right">(P)</b>
          <b *ngIf="!isGroupRates && (isGroupRate | call : element)" matTooltip="Group Rate" matTooltipPosition="right"
            >(G)</b
          >
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="rentals" *ngIf="isGroupRates">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Rentals</mat-header-cell>
        <mat-cell
          *matCellDef="let element"
          [matTooltip]="getRentalsTooltip | call : element.rentalIds"
          matTooltipPosition="above"
          matTooltipClass="text-center"
        >
          {{ element.rentalIds.length }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="period">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Rate Period</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.start | epochUTC : 'MMM D, YYYY' }} - {{ element.end | epochUTC : 'MMM D, YYYY' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="nightly">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Nightly</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.nightly ? (element.nightly | rate : currency : false) : '...' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="weekly">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Weekly</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.weekly ? (element.weekly | rate : currency : false) : '...' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="monthly">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Monthly</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.monthly ? (element.monthly | rate : currency : false) : '...' }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="minimumStay">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Min Stay</mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.minimumStay }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef> EDIT</mat-header-cell>

        <mat-cell *matCellDef="let element">
          <div
            dropdown
            placement="bottom right"
            container="body"
            [isDisabled]="1 | isReadonlyRole"
            *ngIf="isGroupRates || !(isGroupRate | call : element)"
          >
            <div dropdownToggle (click)="$event.stopPropagation()" class="btn-group btn-ellips-holder">
              <a class="btn-ellips">
                <i class="fas fa-ellipsis-v"></i>
              </a>
            </div>
            <ul *dropdownMenu class="dropdown-menu dropdown-menu-right">
              <li>
                <button (click)="onEdit(element)" type="button"><i class="fal fa-edit"></i>Edit</button>
              </li>
              <li>
                <button (click)="onDelete(element)" type="button" [disabled]="!groupRatesLoaded">
                  <i class="fal fa-trash-alt"></i>Delete
                </button>
              </li>
            </ul>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row
        *matRowDef="let row; columns: displayedColumns"
        (click)="onEdit(row)"
        class="clickable"
        [matTooltip]="getRowTooltip | call : row"
        matTooltipPosition="above"
        matTooltipClass="text-center"
      >
      </mat-row>
    </mat-table>

    <mat-paginator
      #paginator
      [length]="dataSource?.data?.length"
      [class.hidden]="isEmptyTable$ | async"
      (page)="onPageChange($event)"
      [pageSize]="savedPageSize"
      [pageSizeOptions]="[5, 10, 20, 50, 75, 100]"
      [showFirstLastButtons]="true"
    >
    </mat-paginator>

    <app-empty-table *ngIf="isEmptyTable$ | async" [type]="tableType" class="bg-white"></app-empty-table>
  </table>
</div>
